// Neutral not-found for embed (unknown /embed/* paths, a missing agent): never the console login.
const EmbedNotFound = ({
  message = 'This page is not available in embedded mode.',
}: {
  message?: string
}) => (
  <div
    className="flex h-screen items-center justify-center text-p-400 text-st2"
    data-testid="embed-not-found"
  >
    {message}
  </div>
)

export default EmbedNotFound
